import { IonAvatar, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonContent, IonItem, IonLabel, IonList } from '@ionic/react'
import './HelpModal.css'

const HelpModal = ({ step }) => {
    return (
        <IonContent className={'help-modal-root'}>
            {step === 2 && <IonCard>
                <IonCardHeader>
                    <IonCardTitle>Store ID Help</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                    <IonList>
                        <IonItem>
                            <IonAvatar slot="start">
                                <h1>1</h1>
                            </IonAvatar>
                            <IonLabel className={'ion-text-wrap'}>
                                Navigate to <strong>Stores</strong>
                            </IonLabel>
                        </IonItem>
                        <IonItem>
                            <IonAvatar slot="start">
                                <h1>2</h1>
                            </IonAvatar>
                            <IonLabel className={'ion-text-wrap'}>
                                Select Store
                            </IonLabel>
                        </IonItem>
                        <IonItem>
                            <IonAvatar slot="start">
                                <h1>3</h1>
                            </IonAvatar>
                            <IonLabel className={'ion-text-wrap'}>
                                Find Store ID in <strong>General Settings</strong>
                            </IonLabel>
                        </IonItem>
                    </IonList>
                </IonCardContent>
                <img src={require('assets/images/store_id_help.png')} alt="store_id help" />
            </IonCard>}
            {step === 3 && <IonCard>

                <IonCardHeader>
                    <IonCardTitle>Generate Invoice API Key</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                    <IonList>
                        <IonItem>
                            <IonAvatar slot="start">
                                <h1>1</h1>
                            </IonAvatar>
                            <IonLabel className={'ion-text-wrap'}>
                                Select Profile
                            </IonLabel>
                        </IonItem>
                        <IonItem>
                            <IonAvatar slot="start">
                                <h1>2</h1>
                            </IonAvatar>
                            <IonLabel className={'ion-text-wrap'}>
                                Navigate to API Keys
                            </IonLabel>
                        </IonItem>
                        <IonItem>
                            <IonAvatar slot="start">
                                <h1>3</h1>
                            </IonAvatar>
                            <IonLabel className={'ion-text-wrap'}>
                                Generate New Key
                            </IonLabel>
                        </IonItem>
                        <IonItem>
                            <IonAvatar slot="start">
                                <h1>4</h1>
                            </IonAvatar>
                            <IonLabel className={'ion-text-wrap'}>
                                Select 'Create invoices the lightning nodes associated with your stores' and <strong>Generate API Key</strong>
                            </IonLabel>
                        </IonItem>
                        <img src={require('assets/images/invoice_api_key_help.png')} alt="invoice api key help" />
                        <IonItem>
                            <IonAvatar slot="start">
                                <h1>5</h1>
                            </IonAvatar>
                            <IonLabel className={'ion-text-wrap'}>
                                Click to reveal key and paste into Oshi
                            </IonLabel>
                        </IonItem>
                    </IonList>
                </IonCardContent>
            </IonCard>}
        </IonContent>
    )
}

export default HelpModal